import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from '../../../axiosInstance';
import { useTranslation } from "react-i18next";
import DataTableComponent from "../../common/DataTable/PrimeDataTable";
import DeleteModal from '../../common/DeleteModal';

const FormList = ({persona}) => {
  const [resp] = useState("");
  const [t] = useTranslation();
  const [data, setData] = useState([]);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState({ open: false, record: null });
  const [paginationParams, setPaginationParams] = useState({
      limit: 10,
      offset: 0,
      sortField: "createdAt",
      sortOrder: -1
    });
  const navigate = useNavigate();
  // const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    fetchForms();
    }, [paginationParams]);

  const fetchForms = async () => {
    const response = await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/forms`, { withCredentials: true })
    .catch((err) => {
        console.log(err);
    });
    
    setData(response?.data);
  };

  const onDataTableEvent = (event) => {
    setPaginationParams((prev) => ({
      ...prev,
      limit: event.rows,
      offset: event.first,
      sortField: event.sortField || prev.sortField,
      sortOrder: event.sortOrder || prev.sortOrder
    }));
  };

  const columns = [
      { field: "id", header: "ID", sortable: true },
      { field: "name", header: t("name"), sortable: true, filter: true },
      { field: "published", header: t("status"), sortable: true, filter: true, body: (rowData) => rowData.published === true ? "Published" : "UnPublished" },
      { field: "subForms", header: t("subForms"), sortable: true, filter: true, body: (rowData) => [...rowData.subforms.map((subform, index) => (
          <Link
            className="table-li-links"
            key={subform.id}
            to={`/admin/subforms/details/${subform.id}`}
          >
            {index + 1} - {subform.name}
            <br />
          </Link>
      )),] },
      { field: "createdBy", header: t("createdBy"), sortable: true, filter: true, body: (rowData) => rowData.User?.username },
    { field: "createdAt", header: t("createdAt"), sortable: true, filter: true, body: (rowData) => new Date(rowData.createdAt).toLocaleString('en-GB') },
  ];

  const actions = [
    { text: "View", color: "primary", onClick: (row) => navigate(`/${persona}/forms/details/${row.id}`) },
    { text: t("edit"), color: "secondary", onClick: (row) => navigate(`/${persona}/forms/edit/${row.id}`) },
    // { text: "Delete", onClick: (row) => setConfirmDeleteModal({ open: true, record: row }), color: "primary", status: 'danger' },
  ];

    return (
      <div>
        {resp && <p>{resp}</p>}

        <DataTableComponent
        data={data}
        columns={columns}
        actions={actions}
        totalRecords={data?.length}
        enableCreate={true}
        enablePagination={true}
        paginationParams={paginationParams}
        onDataTableEvent={onDataTableEvent}
        enableLazyLoading={false}
        // enableSelection= {true}
        // selection={selectedRows}
        // onSelectionChange={(e) => setSelectedRows(e.value)}
        // selectionMode="multiple"
        />

        {confirmDeleteModal && (
          <DeleteModal
            sentData={confirmDeleteModal.record}
            onEvent={setConfirmDeleteModal}
            onConfirm={fetchForms}
            apiPath="forms"
            axios={axiosInstance}
            columnName="name"
          />
        )}
      </div>
    );
};

export default FormList;
